var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-apple_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161157",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31314"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31313",
  clipPath: "url(#icon-apple_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38601",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31316"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31315",
  clipPath: "url(#icon-apple_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38602",
  d: "M33.397 24.275s.085-9.776-9.9-9.776c0 0-.947 9.776 9.9 9.776",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38603",
  d: "M34.366 25.253h-.969c-3.674 0-6.5-1.061-8.4-3.153a10.847 10.847 0 01-2.477-7.695l.086-.883h.887a10.485 10.485 0 017.764 2.886 12.028 12.028 0 013.117 7.875zm-9.9-9.741a8.535 8.535 0 001.994 5.287 8.4 8.4 0 005.883 2.465 9.661 9.661 0 00-2.482-5.49 8.193 8.193 0 00-5.4-2.262",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38604",
  d: "M31.334 23.004s1.582-6.1 5.877-8.138l2.889 3.166s-5.2 3.164-4.383 5.876",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38605",
  d: "M35.716 24.886a.978.978 0 01-.935-.7c-.779-2.589 2.183-5.149 3.832-6.337l-1.608-1.759c-3.364 2.087-4.711 7.107-4.725 7.16a.977.977 0 01-1.892-.492c.069-.267 1.751-6.571 6.4-8.776a.976.976 0 011.14.224l2.889 3.166a.977.977 0 01-.214 1.493 16.166 16.166 0 00-2.355 1.816c-1.247 1.182-1.815 2.227-1.6 2.943a.978.978 0 01-.936 1.259",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38606",
  d: "M33.491 25.494s-6.761-6.506-13.182-.832-3.556 30.05 10.779 23.779",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38607",
  d: "M26.651 50.446c-3.106 0-5.754-1.554-7.694-4.594-4.143-6.491-3.776-17.965.7-21.922a9.418 9.418 0 019.983-1.9 14.2 14.2 0 014.523 2.757.977.977 0 01-1.352 1.409c-.259-.247-6.2-5.8-11.858-.8-3.729 3.295-3.918 13.814-.349 19.406 2.952 4.625 7.116 4.046 10.089 2.745a.977.977 0 11.783 1.791 12.086 12.086 0 01-4.826 1.11",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38608",
  d: "M27.67 46.499a26.645 26.645 0 003.677 1.942c15.554 6.272 19.055-17.413 12.44-23.778-4.672-4.5-9.277-1.846-11.253-.278l-1.426 1.423",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38609",
  d: "M36.265 50.478a14.15 14.15 0 01-5.292-1.131l-.029-.012a26.223 26.223 0 01-3.877-2.06.977.977 0 011.19-1.55 24.644 24.644 0 003.462 1.816c6.273 2.523 9.787-.338 11.63-3.185a18.774 18.774 0 002.627-10.373c-.082-3.742-1.156-6.963-2.875-8.616s-5.3-3.89-9.926-.25L31.79 26.5a.977.977 0 01-1.381-1.383l1.425-1.423a.954.954 0 01.083-.074 11.021 11.021 0 015.079-2.336 8.61 8.61 0 017.46 2.675c4.4 4.237 4.673 15.068.533 21.46a10.3 10.3 0 01-8.725 5.06",
  fill: "#283c8c"
})))));
export default __webpack_public_path__ + "static/icon-apple.45b2cc6e76a724e962268b314573660c.svg";
export { SvgIconApple as ReactComponent };